<ng-container [ngSwitch]="report.detalization">
    <ng-template [ngSwitchCase]="'Consolidated'">
        <div class="section-header m-t-30 m-b-20">
            {{report.title}}
        </div>
        <consolidated-table *ngFor="let table of report.tables; first as isFirst"
                            [table] ="table" [isFirst]="iFirst"></consolidated-table>
    </ng-template>
    <ng-template [ngSwitchCase]="'Detailed'">
        <div class="row section-header m-t-30">
            <div class="col-6">{{report.title}}</div>
            <div class="col-1">4.2</div>
        </div>
        <detailed-table *ngFor="let table of report.tables" [table] ="table"></detailed-table>
    </ng-template>
</ng-container>